import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function AddChildModal({
  open,
  onOpenChange,
  addChildForm,
  setAddChildForm,
  addChildLoading,
  handleAddChild
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Another Child</DialogTitle>
          <DialogDescription>Register another child under your account</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium">Name *</label>
              <Input value={addChildForm.name} onChange={(e) => setAddChildForm({...addChildForm, name: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium">Age *</label>
              <Input type="number" value={addChildForm.age} onChange={(e) => setAddChildForm({...addChildForm, age: e.target.value})} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium">Grade *</label>
              <Input type="number" value={addChildForm.grade} onChange={(e) => setAddChildForm({...addChildForm, grade: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium">Phone (WhatsApp) *</label>
              <Input value={addChildForm.phone} onChange={(e) => setAddChildForm({...addChildForm, phone: e.target.value})} placeholder="+91..." />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium">School</label>
            <Input value={addChildForm.school_name} onChange={(e) => setAddChildForm({...addChildForm, school_name: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium">Curriculum Board *</label>
            <select
              value={addChildForm.board || "cbse"}
              onChange={(e) => setAddChildForm({...addChildForm, board: e.target.value})}
              data-testid="add-child-board-select"
              className="mt-1 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <option value="cbse">CBSE</option>
              <option value="ib">IB (International Baccalaureate)</option>
            </select>
          </div>
          <p className="text-[11px] text-gray-400 -mt-1">
            Content is aligned to the selected board to the best of our ability; occasional variations from the official syllabus may occur.
          </p>
          <div>
            <label className="text-sm font-medium">Subjects</label>
            <Input value={addChildForm.subjects_required} onChange={(e) => setAddChildForm({...addChildForm, subjects_required: e.target.value})} placeholder="Math, Science, English..." />
          </div>
          <Button onClick={handleAddChild} disabled={addChildLoading} className="w-full">
            {addChildLoading ? "Adding..." : "Add Child"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
